import React, { useEffect, useState } from "react";
import HeroCarouselV2 from "./v2/HeroCarouselV2";
import HeroSectionV2 from "./v2/HeroSectionV2";
import PromoCardSliderV2 from "./v2/PromoCardSliderV2";
import { HomeBanner } from "@/packages/types/banner";
import { fetchAllHomeSliders } from "@/api-service/banner";

type SliderWithPromotionalProps = {
  className?: string;
};

const SliderWithOnePromo: React.FC<SliderWithPromotionalProps> = () => {
  const [banners, setBanners] = useState<HomeBanner[]>([]);
  const [promoBanners, setPromoBanners] = useState<HomeBanner[]>([]);

  useEffect(() => {
    let isMounted = true;
    const loadBanners = async () => {
      try {
        const res = await fetchAllHomeSliders();
        if (isMounted) {
          setBanners(res.data.sliders || []);
          setPromoBanners(res.data.promoCards || []);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    loadBanners();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <HeroSectionV2
      carousel={<HeroCarouselV2 banners={banners} className="w-full h-full" />}
      promoComponent={
        promoBanners.length > 0 ? (
          <PromoCardSliderV2 promoCards={promoBanners} className="w-full h-full" />
        ) : undefined
      }
    />
  );
};

export default SliderWithOnePromo;
